class OnboardingLinkNavigationCtrl {
  constructor() {
    'ngInject';
  }
}

export default OnboardingLinkNavigationCtrl;
